import { useLog } from 'contexts/results';

const Log = () => {
  const log = useLog();
  return <pre id='log'>{log.join('\n')}</pre>;
};

export default Log;
